import request from '@/utils/request'

/**
 *  中标候选人结果公告
 * */
// 保存、提交
export const winBulletinAdd = (data) => {
  return request.post('/api/agent/winBulletin/add', data)
}
//标段列表
export const winBulletinBidSectionList = (data) => {
  return request.get('/api/agent/winBulletin/bidSectionList?projectCode='+data.projectCode)
}
//获取标段候选人信息
export const winBulletinBidders = (data) => {
  return request.get('/api/agent/winBulletin/bidders?bidSectionCode='+data.bidSectionCode +"&stage="+data.stage)
}
//删除
export const winBulletinDelete = (data) => {
  return request.post('/api/agent/winBulletin/delete?winBulletinCode='+data.winBulletinCode)
}
//详情
export const winBulletinDetail = (data) => {
  return request.get('/api/agent/winBulletin/detail?winBulletinCode='+data.winBulletinCode)
}
//列表
export const winBulletinList = (data) => {
  return request.get('/api/agent/winBulletin/list?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize)
}

/**
 *  审核阶段
 * */
// 审核
export const AuditwinBulletinCheck = (data) => {
  return request.post('/api/agent/audit/winBulletin/check', data)
}
// 详情
export const AuditwinBulletinDetail = (data) => {
  return request.get('/api/agent/audit/winBulletin/detail?winBulletinCode='+data.winBulletinCode)
}
// 列表
export const AuditwinBulletinList = (data) => {
  return request.get('/api/agent/audit/winBulletin/list?status='+data.status +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize+"&winBulletinName="+data.winBulletinName)
}

/**
 *  中标通知书
 * */
// 保存、提交
export const awardNoticeAdd = (data) => {
  return request.post('/api/agent/awardNotice/add', data)
}
// 标段列表
export const awardNoticeBidSectionList = (data) => {
  return request.get('/api/agent/awardNotice/bidSectionList?projectCode='+data.projectCode)
}
//获取标段中标人信息
export const awardNoticeBidders = (data) => {
  return request.get('/api/agent/awardNotice/bidders?bidSectionCode='+data.bidSectionCode)
}
//删除
export const awardNoticeDelete = (data) => {
  return request.post('/api/agent/awardNotice/delete?awardNoticeCode='+data.awardNoticeCode)
}
//详情
export const awardNoticeDetail = (data) => {
  return request.get('/api/agent/awardNotice/detail?awardNoticeCode='+data.awardNoticeCode)
}
//列表
export const awardNoticeList = (data) => {
  return request.get('/api/agent/awardNotice/list?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize+"&bidSectionName="+data.bidSectionName)
}

export const bidderAwardNoticeList = (data) => {
  return request.get('/api/agent/awardNotice/bidderList?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize+"&bidSectionName="+data.bidSectionName)
}
